var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
import apiClient from '@utils/api-client';
// ---------------------------------------------------------------------------
// AI Token — POST /api/internal/ai/token (Rails, session auth)
// ---------------------------------------------------------------------------
export function requestAiToken() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClient.post('/api/internal/ai/token');
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('[aiTokenApi] Error requesting AI token:', error);
            const errorMessage = error instanceof Error ? error.message : 'Failed to fetch AI token';
            return {
                error: {
                    message: errorMessage,
                    errors: error
                }
            };
        }
    });
}
